import { baseSplitApi as api } from "./baseApi";

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getBackOfficeListLecturers: build.query<
      GetBackOfficeListLecturersApiResponse,
      GetBackOfficeListLecturersApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/bo/lecturers`,
        params: {
          page: queryArg.page,
          size: queryArg.size,
          keyword: queryArg.keyword,
          sort: queryArg.sort,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as bigsystherApi };
export type GetBackOfficeListLecturersApiResponse =
  /** status 200 OK */ BackOfficeLecturerPage;
export type GetBackOfficeListLecturersApiArg = {
  /** page */
  page?: number;
  /** size */
  size?: number;
  /** keyword to search */
  keyword?: string;
  /** Format is sort=distance:desc,name:asc. Supported keys: createdAt, updatedAt, name, email */
  sort?: string[];
};
export type CookieResponse = {
  domain?: string;
  httpOnly?: boolean;
  maxAge?: number;
  name?: string;
  path?: string;
  secure?: boolean;
  value?: string;
};
export type AudioResponse = {
  cookies?: CookieResponse[];
  url?: string;
};
export type AudioMediaResponse = {
  content?: AudioResponse;
  id?: string;
};
export type ImageResponse = {
  type?: string;
  url?: string;
};
export type ImageMediaResponse = {
  content?: ImageResponse[];
  id?: string;
};
export type EntityMediaType = "image" | "video" | "audio";
export type VideoResponse = {
  cookies?: CookieResponse[];
  thumbnail?: ImageResponse[];
  url?: string;
};
export type VideoMediaResponse = {
  content?: VideoResponse;
  id?: string;
};
export type EntityMedia = {
  audio?: AudioMediaResponse;
  createdAt?: string;
  id?: string;
  image?: ImageMediaResponse;
  key?: string;
  type?: EntityMediaType;
  updatedAt?: string;
  video?: VideoMediaResponse;
};
export type EntityLanguage = "en" | "de" | "de";
export type EntityLecturerTranslation = {
  description?: string;
  id?: string;
  language?: EntityLanguage;
};
export type EntityLecturer = {
  contactEmail?: string;
  createdAt?: string;
  fullName?: string;
  id?: string;
  lecturerImage?: EntityMedia;
  translations?: EntityLecturerTranslation[];
  updatedAt?: string;
};
export type BackOfficeLecturerPage = {
  count?: number;
  items?: EntityLecturer[];
  last?: boolean;
  page?: number;
  size?: number;
};
export type ValidationError = {
  field?: string;
  message?: string;
};
export type ErrorResponse400 = {
  code?: number;
  data?: ValidationError[];
  message?: string;
};
export type ErrorResponse404 = {
  code?: number;
  data?: {
    [key: string]: string;
  }[];
  message?: string;
};
export const { useGetBackOfficeListLecturersQuery } = injectedRtkApi;
